"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeLatex = sanitizeLatex;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jquery = _interopRequireDefault(require("jquery"));

var _uuid = _interopRequireDefault(require("uuid"));

var _menuK12En = _interopRequireDefault(require("../../menuConfigs/menu-k12-en"));

var _defaultMenu = _interopRequireDefault(require("../../menuConfigs/default-menu"));

var _menuChemistry = _interopRequireDefault(require("../../menuConfigs/menu-chemistry"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// export for others scripts to use
window.$ = _jquery.default;
window.jQuery = _jquery.default;

require('../../lib/mathquill.min');

var MathquillUIMenu = require('./MathquillUIMenu');

function getUID() {
  return _uuid.default.v4();
}

function sanitizeLatex(latex) {
  var sanitized = latex.replace(/\\?>\s?/g, '\\gt ') // The trailing space is needed to prevent it from "merging" with following characters.
  .replace(/\\?<\s?/g, '\\lt ');

  if (sanitized.slice(-1) === '\\') {
    // An ending backslash will cause the whole thing to go blank.
    return "".concat(sanitized, " ");
  }

  return sanitized;
}

var MathquillUIElement = /*#__PURE__*/function (_React$Component) {
  _inherits(MathquillUIElement, _React$Component);

  var _super = _createSuper(MathquillUIElement);

  function MathquillUIElement(props) {
    var _this;

    _classCallCheck(this, MathquillUIElement);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onWindowMouseDown", function () {
      var _this2;

      return (_this2 = _this).__onWindowMouseDown__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "insertMathField", function () {
      var _this3;

      return (_this3 = _this).__insertMathField__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "removeInFocusClass", function () {
      var _this4;

      return (_this4 = _this).__removeInFocusClass__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "isChildOfThisInstanceDOMNode", function () {
      var _this5;

      return (_this5 = _this).__isChildOfThisInstanceDOMNode__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "setCurrentMath", function () {
      var _this6;

      return (_this6 = _this).__setCurrentMath__REACT_HOT_LOADER__.apply(_this6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "displayMenu", function () {
      var _this7;

      return (_this7 = _this).__displayMenu__REACT_HOT_LOADER__.apply(_this7, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "removeMenu", function () {
      var _this8;

      return (_this8 = _this).__removeMenu__REACT_HOT_LOADER__.apply(_this8, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getRenderedContentWidth", function () {
      var _this9;

      return (_this9 = _this).__getRenderedContentWidth__REACT_HOT_LOADER__.apply(_this9, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onMathEditorClicked", function () {
      var _this10;

      return (_this10 = _this).__onMathEditorClicked__REACT_HOT_LOADER__.apply(_this10, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getWrapperEl", function () {
      var _this11;

      return (_this11 = _this).__getWrapperEl__REACT_HOT_LOADER__.apply(_this11, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onTriggerMenuClick", function () {
      var _this12;

      return (_this12 = _this).__onTriggerMenuClick__REACT_HOT_LOADER__.apply(_this12, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "getLatex", function () {
      var _this13;

      return (_this13 = _this).__getLatex__REACT_HOT_LOADER__.apply(_this13, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "setMathText", function () {
      var _this14;

      return (_this14 = _this).__setMathText__REACT_HOT_LOADER__.apply(_this14, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function () {
      var _this15;

      return (_this15 = _this).__onMouseDown__REACT_HOT_LOADER__.apply(_this15, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function () {
      var _this16;

      return (_this16 = _this).__onMouseUp__REACT_HOT_LOADER__.apply(_this16, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onMenuMouseDown", function () {
      var _this17;

      return (_this17 = _this).__onMenuMouseDown__REACT_HOT_LOADER__.apply(_this17, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onMenuMouseUp", function () {
      var _this18;

      return (_this18 = _this).__onMenuMouseUp__REACT_HOT_LOADER__.apply(_this18, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onMenuReady", function () {
      var _this19;

      return (_this19 = _this).__onMenuReady__REACT_HOT_LOADER__.apply(_this19, arguments);
    });

    _this.menuComponent = undefined; // MathquillUIMenu

    _this.mathEditableEl = undefined;
    _this.mathStaticEl = undefined;
    _this.mouseIsDownInside = false;
    _this.state = {
      initialized: false,
      mathquillText: _this.props.mathquillText
    };
    return _this;
  }

  _createClass(MathquillUIElement, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      if (typeof MathQuill.getInterface === 'function') {
        this.MQ = MathQuill.getInterface(2);
      }

      this.menuData = this.getMenuData(this.props.symbolsToHide);
      this.id = this.props.id ? this.props.id : getUID();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isStaticMathElement) {
        this.MQ.StaticMath(this.mathStaticEl);
      } else {
        var mathField = this.insertMathField();
        this.setCurrentMath(mathField, false);
        window.addEventListener('mousedown', this.onWindowMouseDown, false);
        this.setState({
          initialized: true
        });
      }

      if (typeof this.props.onInstanceReady === 'function') {
        this.props.onInstanceReady(this);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.isStaticMathElement) {
        this.MQ.StaticMath(this.mathStaticEl);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousedown', this.onWindowMouseDown, false);
    }
  }, {
    key: "__onWindowMouseDown__REACT_HOT_LOADER__",
    value: function __onWindowMouseDown__REACT_HOT_LOADER__(e) {
      if (this.props.isStaticMathElement) {
        return;
      }

      var $targetEl = (0, _jquery.default)(e.target);

      if (this.mouseIsDownInside) {// no need to remove focus or the menu
        // if clicked on a inner mathquill element
      } else {
        this.removeInFocusClass($targetEl);
        this.removeMenu();
      }
    }
  }, {
    key: "__insertMathField__REACT_HOT_LOADER__",
    value: function __insertMathField__REACT_HOT_LOADER__() {
      var _this20 = this;

      return this.MQ.MathField(this.mathEditableEl, {
        handlers: {
          edit: function edit(mathField) {
            if (typeof _this20.props.mathEditableChangeCallback === 'function') {
              _this20.props.mathEditableChangeCallback(mathField);
            }
          }
        }
      });
    }
  }, {
    key: "__removeInFocusClass__REACT_HOT_LOADER__",
    value: function __removeInFocusClass__REACT_HOT_LOADER__($targetEl) {
      if (!this.isChildOfThisInstanceDOMNode($targetEl)) {
        (0, _jquery.default)(".".concat(this.props.inFocusClass)).removeClass(this.props.inFocusClass);
      }
    }
  }, {
    key: "__isChildOfThisInstanceDOMNode__REACT_HOT_LOADER__",
    value: function __isChildOfThisInstanceDOMNode__REACT_HOT_LOADER__($targetEl) {
      var _this21 = this;

      if (!$targetEl) {
        return false;
      }

      var filteredParents = $targetEl.parents().filter(function (idx, element) {
        return (0, _jquery.default)(element).find("#".concat(_this21.props.id)).length === 1;
      });
      return filteredParents.length === 1;
    }
  }, {
    key: "__setCurrentMath__REACT_HOT_LOADER__",
    value: function __setCurrentMath__REACT_HOT_LOADER__(currentMathEditor) {
      var forceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var forceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.currentMathEditor = currentMathEditor;

      if (forceUpdate) {
        this.forceUpdate();
      }
    }
  }, {
    key: "__displayMenu__REACT_HOT_LOADER__",
    value: function __displayMenu__REACT_HOT_LOADER__() {
      this.menuComponent.show();
      this.getWrapperEl().addClass('showing-menu');
    }
  }, {
    key: "__removeMenu__REACT_HOT_LOADER__",
    value: function __removeMenu__REACT_HOT_LOADER__() {
      var $wrapperEl = this.getWrapperEl();
      $wrapperEl.removeClass('showing-menu');
      this.menuComponent.hide();
    }
  }, {
    key: "__getRenderedContentWidth__REACT_HOT_LOADER__",
    value: function __getRenderedContentWidth__REACT_HOT_LOADER__() {
      var renderedContentWrapper = this.mathEditableEl.querySelector('.mq-root-block');
      return renderedContentWrapper ? renderedContentWrapper.scrollWidth : 0;
    }
  }, {
    key: "__onMathEditorClicked__REACT_HOT_LOADER__",
    value: function __onMathEditorClicked__REACT_HOT_LOADER__() {
      if (this.currentMathEditor === undefined) {
        return false;
      }

      this.removeInFocusClass();
      this.getWrapperEl().addClass(this.props.inFocusClass);
      this.currentMathEditor.focus();

      if (this.props.triggerOnClick) {
        this.displayMenu();
        return false;
      }

      return undefined;
    }
  }, {
    key: "__getWrapperEl__REACT_HOT_LOADER__",
    value: function __getWrapperEl__REACT_HOT_LOADER__() {
      return (0, _jquery.default)(this.props.wrapper);
    }
  }, {
    key: "__onTriggerMenuClick__REACT_HOT_LOADER__",
    value: function __onTriggerMenuClick__REACT_HOT_LOADER__() {
      // the trigger button should toggle the menu
      if (this.menuComponent.state.showing) {
        this.removeMenu();
      } else {
        var $wrapperEl = this.getWrapperEl();
        this.displayMenu();
        this.removeInFocusClass();
        $wrapperEl.addClass(this.props.inFocusClass);
      }

      return false;
    }
  }, {
    key: "getMenuData",

    /**
     * @param {array} symbolsToHide Array of latex symbols E.g. \\degree
     * @return {*}
     */
    value: function getMenuData(symbolsToHide) {
      var menuUrl = window.marketplaceProperties.IA_MATH_MENU_JSON_URL || '';
      var menuData;

      if (this.props.menuData) {
        menuData = this.props.menuData;
      } else if (menuUrl.indexOf('menu-k12-en') !== -1) {
        menuData = _menuK12En.default;
      } else if (menuUrl.indexOf('menu-chemistry') !== -1) {
        menuData = _menuChemistry.default;
      } else {
        menuData = _defaultMenu.default;
      }

      if (!symbolsToHide) {
        return menuData;
      }

      return this.filterOutSymbols(menuData, symbolsToHide);
    }
    /**
     * @param {object} menuData
     * @param {array} symbolsToHide Array of latex symbols E.g. \\degree
     * @return {*} clone of menuData with symbolsToHide filtered out.
     */

  }, {
    key: "filterOutSymbols",
    value: function filterOutSymbols(menuData, symbolsToHide) {
      var getGroups = function getGroups(item) {
        return item.groups.map(function (group) {
          var symbols = group.symbols.filter(function (symbol) {
            return symbolsToHide.indexOf(symbol.latex) === -1;
          });
          return {
            symbols: symbols
          };
        });
      };

      return menuData.map(function (item) {
        return {
          groups: getGroups(item),
          label: item.label,
          id: item.id
        };
      });
    }
  }, {
    key: "__getLatex__REACT_HOT_LOADER__",
    value: function __getLatex__REACT_HOT_LOADER__() {
      var math = this.currentMathEditor;
      return math !== undefined ? math.latex() : '';
    }
  }, {
    key: "__setMathText__REACT_HOT_LOADER__",
    value: function __setMathText__REACT_HOT_LOADER__(latex) {
      var mathEditor = this.currentMathEditor;

      if (mathEditor !== undefined) {
        mathEditor.latex(sanitizeLatex(latex));
      }
    }
  }, {
    key: "__onMouseDown__REACT_HOT_LOADER__",
    value: function __onMouseDown__REACT_HOT_LOADER__(e) {
      var $inFocusParents = (0, _jquery.default)(this.componentNode).parents(".".concat(this.props.inFocusClass));
      this.mouseIsDownInside = true;

      if ($inFocusParents.length > 0) {
        e.stopPropagation();
        return false;
      }

      return undefined;
    }
  }, {
    key: "__onMouseUp__REACT_HOT_LOADER__",
    value: function __onMouseUp__REACT_HOT_LOADER__() {
      this.mouseIsDownInside = false;
    }
  }, {
    key: "__onMenuMouseDown__REACT_HOT_LOADER__",
    value: function __onMenuMouseDown__REACT_HOT_LOADER__(e) {
      this.onMouseDown(e);
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }, {
    key: "__onMenuMouseUp__REACT_HOT_LOADER__",
    value: function __onMenuMouseUp__REACT_HOT_LOADER__(e) {
      this.onMouseUp();
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }, {
    key: "__onMenuReady__REACT_HOT_LOADER__",
    value: function __onMenuReady__REACT_HOT_LOADER__(menuComponent) {
      this.menuComponent = menuComponent;

      if (this.props.initiallyActive) {
        this.displayMenu();
        this.getWrapperEl().addClass(this.props.inFocusClass);
        this.currentMathEditor.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this22 = this;

      if (this.props.isStaticMathElement) {
        var _latex = sanitizeLatex(this.props.mathquillText);

        return /*#__PURE__*/_react.default.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: _latex
          },
          ref: function ref(element) {
            _this22.mathStaticEl = element;
          }
        });
      }

      var latex = sanitizeLatex(this.state.mathquillText);
      return /*#__PURE__*/_react.default.createElement("span", {
        // eslint-disable-line jsx-a11y/no-static-element-interactions
        className: "mathquill-ui-root",
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        ref: function ref(span) {
          _this22.componentNode = span;
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        // eslint-disable-line
        id: this.id,
        ref: function ref(editable) {
          _this22.mathEditableEl = editable;
        },
        className: "mathquill-editable",
        onClick: this.onMathEditorClicked,
        dangerouslySetInnerHTML: {
          __html: latex
        }
      }), this.state.initialized ? /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("button", {
        "aria-label": this.props.captions.mathQuill.symbolsMenu,
        className: "mathquill-ui-trigger",
        onClick: this.onTriggerMenuClick,
        dangerouslySetInnerHTML: {
          __html: '&Sigma;'
        }
      }), /*#__PURE__*/_react.default.createElement("span", {
        // eslint-disable-line jsx-a11y/no-static-element-interactions
        className: "mathquill-ui-menu-wrapper",
        onMouseDown: this.onMenuMouseDown,
        onMouseUp: this.onMenuMouseUp
      }, /*#__PURE__*/_react.default.createElement(MathquillUIMenu, {
        onInstanceReady: this.onMenuReady,
        captions: this.props.captions,
        currentMath: this.currentMathEditor,
        menuData: this.menuData,
        menuClass: this.props.menuClass
      }))) : null, this.props.extraChildren);
    }
  }]);

  return MathquillUIElement;
}(_react.default.Component);

_defineProperty(MathquillUIElement, "propTypes", {
  captions: _propTypes.default.object,
  extraChildren: _propTypes.default.any,
  mathEditableChangeCallback: _propTypes.default.func,
  mathquillText: _propTypes.default.string,
  menuClass: _propTypes.default.string,
  id: _propTypes.default.string,
  inFocusClass: _propTypes.default.string,
  initiallyActive: _propTypes.default.bool,
  isStaticMathElement: _propTypes.default.bool,
  onInstanceReady: _propTypes.default.func,
  symbolsToHide: _propTypes.default.array,
  triggerOnClick: _propTypes.default.bool,
  menuData: _propTypes.default.object,
  wrapper: _propTypes.default.object
});

_defineProperty(MathquillUIElement, "defaultProps", {
  captions: {
    mathQuill: {
      basicTab: 'Basic symbols',
      chemistryTab: 'Chemistry symbols',
      advancedTab: 'Advanced symbols',
      symbolsMenu: 'Symbols menu'
    }
  },
  extraChildren: [],
  id: undefined,
  initiallyActive: false,
  inFocusClass: 'mq-in-focus',
  isStaticMathElement: false,
  mathquillText: '',
  menuClass: 'mathquill-ui-menu',
  symbolsToHide: undefined,
  triggerOnClick: false
});

var _default = MathquillUIElement;
var _default2 = _default;
exports.default = _default2;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getUID, "getUID", "/opt/TeamCity/buildAgent2/work/63f390c34456f15a/src/js/components/MathquillUIElement.js");

  __REACT_HOT_LOADER__.register(sanitizeLatex, "sanitizeLatex", "/opt/TeamCity/buildAgent2/work/63f390c34456f15a/src/js/components/MathquillUIElement.js");

  __REACT_HOT_LOADER__.register(MathquillUIElement, "MathquillUIElement", "/opt/TeamCity/buildAgent2/work/63f390c34456f15a/src/js/components/MathquillUIElement.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/opt/TeamCity/buildAgent2/work/63f390c34456f15a/src/js/components/MathquillUIElement.js");
}();

;